import axiosInstance from '../axios';
import endpoints from '../endpoints';

const paymentService = {
  // Initialize Paystack payment
  initializePayment: async (paymentData) => {
    const response = await axiosInstance.post(endpoints.payments.initialize, paymentData);
    return response.data;
  },

  // Verify payment
  verifyPayment: async (reference) => {
    const response = await axiosInstance.get(endpoints.payments.verify(reference));
    return response.data;
  },

  // Get payments for contest
  getContestPayments: async (contestId, params = {}) => {
    const { page = 1, pageSize = 20 } = params;
    const queryParams = new URLSearchParams({ page, pageSize });
    
    const response = await axiosInstance.get(`${endpoints.payments.byContest(contestId)}?${queryParams}`);
    return response.data;
  },

  // Get payment statistics
  getPaymentStats: async (contestId) => {
    const response = await axiosInstance.get(endpoints.payments.stats(contestId));
    return response.data;
  }
};

export default paymentService;